import { Link } from "react-router-dom";
import type { Actor } from "@/mocks/actors";

interface ActorCardProps {
  actor: Actor;
}

export default function ActorCard({ actor }: ActorCardProps) {
  return (
    <Link to={`/actor/${actor.id}`} className="group block cursor-pointer">
      <div className="aspect-[3/4] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={actor.avatar}
          alt={`${actor.name}头像`}
          title={`${actor.name} 演员头像`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <h3 className="mt-2 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
        {actor.name}
      </h3>
      <p className="mt-0.5 truncate text-xs text-foreground-500">
        饰 {actor.signatureRoles[0]}
      </p>
    </Link>
  );
}